import React, { FC } from "react";

import {
  basketActiveAtom,
  basketSelector,
  DataViewKey,
  dataViewPage,
  KpkBasket,
  SentryBreadcrumbCategory,
  useBasketList,
} from "@keepeek/commons";
import { BasketLayout, withSuspense } from "@keepeek/refront-components";
import { LinearProgress } from "@mui/material";
import * as Sentry from "@sentry/nextjs";
import { useRouter } from "next/router";
import { useRecoilState, useRecoilValue } from "recoil";

import { KIcon } from "../../../components/common/KIcon";
import { currentBasketIdState } from "../../../providers/basket/atoms";
import { configSectionComponentBasketSelector } from "../../../providers/config/selectors";
import { PagesPath } from "../../App/utils";
import BasketError from "../BasketError";

/**
 * Loading component without total count and paginate
 */
const BasketBasicLoading: FC = function () {
  const router = useRouter();
  const [currentBasketId, setCurrentBasketId] = useRecoilState(currentBasketIdState);
  const currentBasket = useRecoilValue(basketSelector({ id: currentBasketId }));
  const { activateBasketPartitioning } = useRecoilValue(configSectionComponentBasketSelector) ?? {
    activateBasketPartitioning: false,
  };
  const { basketList } = useBasketList({
    basketPartitioning: activateBasketPartitioning,
  });

  const activeBasket = useRecoilValue(basketActiveAtom);
  const [page, setPage] = useRecoilState(dataViewPage(DataViewKey.BASKET));

  const selectCurrentBasketId = (basketId: KpkBasket["id"]) => {
    setCurrentBasketId(basketId);

    Sentry.addBreadcrumb({
      category: SentryBreadcrumbCategory.USER_INTERACTION,
      message: `selectCurrentBasketId: ${basketId}`,
    });
  };

  return (
    <BasketLayout
      basketList={basketList}
      elementCount={-1}
      currentPage={page}
      active={activeBasket}
      handleBasketSelect={selectCurrentBasketId}
      handlePageChange={setPage}
      handleBasketsRouting={() => router.push(PagesPath.BASKETS)}
      currentBasket={currentBasket}
      KIcon={KIcon}
    >
      <LinearProgress />
    </BasketLayout>
  );
};

export default withSuspense(BasketBasicLoading, {
  CustomErrorComponent: BasketError,
});
